// extracted by mini-css-extract-plugin
export var editor = "w_X";